<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" routerLink="/safety-observations">Related Corrective Actions</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button
          class="m-1 mr-2"
          type="button"
          color="primary"
          mat-raised-button
          (click)="onEditCorrectiveAction()"
          matTooltip="Click this button to create a new corerctive action.">
          <mat-icon>add</mat-icon>
          Add Corrective Action
        </button>
      </span>

      <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options.">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          id="search-input"
          matTooltip="Search the corrective actions by name."/>

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          id="search-button"
          matTooltip="Click this button to run the current search.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>

    </div>
  </nav>

  <div class="mat-elevation-z8 scroll-box">
    <mat-paginator #paginator1 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
            matTooltip="Toggle select all records.">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let corrective_action">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(corrective_action.id) : null"
            [checked]="dataSource.selection.isSelected(corrective_action.id)"
            matTooltip="Toggle select this record.">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- The id of the corrective action. -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the id of the corrective actions.">
          ID #
        </th>
        <td mat-cell *matCellDef="let corrective_action">
          {{ corrective_action.id }}
        </td>
      </ng-container>

      <!-- The task/name of the corrective actions. -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the corrective actions.">
          Corrective Action
        </th>
        <td mat-cell *matCellDef="let corrective_action">
          {{ corrective_action.name }}
        </td>
      </ng-container>

      <!-- The type of the corrective actions. -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the type of the corrective actions.">
          Type
        </th>
        <td mat-cell *matCellDef="let corrective_action">
          {{ corrective_action.type }}
        </td>
      </ng-container>

      <!-- The priority of the corrective action. -->
      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the priority of the corrective actions.">
          Priority
        </th>
        <td mat-cell *matCellDef="let corrective_action">
          {{ corrective_action.priority | titlecase }}
        </td>
      </ng-container>

      <!-- The due date of the corrective actions if any. -->
      <ng-container matColumnDef="due">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the due date of the corrective actions.">
          Due Date
        </th>
        <td mat-cell *matCellDef="let corrective_action">
          <span *ngIf="corrective_action.due">
            {{ corrective_action.due | timezoneConvertMedium }}
          </span>
        </td>
      </ng-container>

      <!-- The due date of the corrective actions if any. -->
      <ng-container matColumnDef="due_UTC">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the due date of the corrective actions.">
          Due Date (UTC)
        </th>
        <td mat-cell *matCellDef="let corrective_action">
          <span *ngIf="corrective_action.due">
            {{ corrective_action.due | timezoneConvertUTCMedium }}
          </span>
        </td>
      </ng-container>

      <!-- The completion status of the corrective actions. -->
      <ng-container matColumnDef="completed">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the completion status of the corrective actions.">
          Completed
        </th>
        <td mat-cell *matCellDef="let corrective_action">
          {{ corrective_action.completed ? 'Yes' : 'No' }}
        </td>
      </ng-container>

      <!-- The date the corrective action was created on. -->
      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the corrective action was added.">
          Created At
        </th>
        <td mat-cell *matCellDef="let corrective_action">
          {{ (corrective_action.date_created * 1000) | timezoneConvertMedium }}
        </td>
      </ng-container>

      <!-- The date the corrective action was created on. -->
      <ng-container matColumnDef="date_created_UTC">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the corrective action was added.">
          Created At (UTC)
        </th>
        <td mat-cell *matCellDef="let corrective_action">
          {{ (corrective_action.date_created * 1000) | timezoneConvertUTCMedium }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="180"></th>
        <td mat-cell *matCellDef="let corrective_action">
          <button type="button" mat-button class="mr-3" (click)="onEditCorrectiveAction(corrective_action)">
            Edit
          </button>
          <button type="button" mat-button (click)="onRemove(corrective_action)">
            Delete
          </button>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
    </table>

    <mat-paginator #paginator2 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>
